<template>
  <div>
    <h1 class="text-center mb-5">Strømmåler</h1>
    <v-flex xs12>
      <v-card class="mb-4 mt-4" v-for="(meter, index) in stepValues.meters" :key="index">
        <v-toolbar color="accent" :dark="protocol.dark">
          <v-toolbar-side-icon>
            <v-icon>mdi-power-socket-eu</v-icon>
          </v-toolbar-side-icon>
          <v-toolbar-title>Info om strømmåler</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <TextInput v-model="meter.numbers" @update-fields="updateFields" ></TextInput>
          <v-flex xs12 class="text-right" v-if="stepValues.meters.length > 1">
            <v-btn color="red" class="mb-4 mt-2" @click="removeMeter(index)">Fjern denne måleren</v-btn>
          </v-flex>          
        </v-card-text>
      </v-card>
      <v-btn color="success" class="mb-4 mt-2" @click="addMeter()">Legg til måler</v-btn>
    </v-flex>
    <ImageUploadBox :images="stepValues.images"></ImageUploadBox>
    <StepButtons @next-page="next" @previous-page="previous" :step="this"/>
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
  mixins: [step],
  beforeMount: function() {
    if(!this.protocol.saved_values.powerOrder) {
      this.protocol.saved_values.powerOrder = {}
    }
    this.protocol.saved_values.powerOrder.powerMeter = this.stepValues
    if(this.stepValues.meters == null || this.stepValues.meters == undefined) {
      this.stepValues.meters = []
    }
    if(this.stepValues.meters.length == 0) {
      this.stepValues.meters.push({numbers: JSON.parse(JSON.stringify(this.stepValues.numbers))})
    }
  },
  methods: {
    addMeter: function() {
      this.stepValues.meters.push({numbers: JSON.parse(JSON.stringify(this.stepValues.numbers))})
    },
    removeMeter: function(i) {
      this.stepValues.meters.splice(i, 1)
    }
  },
  computed: {
    finished: function() {
      for(let meter in this.stepValues.meters) {
        if(!this.stepValues.meters[meter].numbers.powerMeterNumber.value) {
          this.$emit("error", "Vennligst legg til målernummer.")
          return false
        }
      }
      return true
    }
  }
};
</script>
